import { render, staticRenderFns } from "./MenuItemHorizontal.vue?vue&type=template&id=61f8e262&scoped=true&"
import script from "./MenuItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./MenuItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemHorizontal.vue?vue&type=style&index=0&id=61f8e262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8e262",
  null
  
)

export default component.exports